export default "__VITE_ASSET__SXbPNUVN__"